
    import I18n from 'i18nObj';
    
      import 'translations/external_toolsModalLauncher';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('external_toolsModalLauncher');
  